import { Component, ReactNode } from "react"
import { Note } from "../classes/Note"
import { BiDotsVerticalRounded, BiShareAlt } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import './../screens/styles/Note.css';
import { Menu, MenuItem } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import ShareNoteModal from "./ShareNoteModal";
import { NotesService } from "../services/notes.service";
import { WithTranslation, withTranslation } from "react-i18next";

interface Iprops extends WithTranslation {
    note: Note;
    onEditNameEnd: (newName: string) => void;
    onEditContentEnd: (newContent: string) => void;
    onDeleteNote: () => void;
}

interface IState {
    shareModalOpen: boolean;
}

class NoteComponent extends Component<Iprops, IState> {

    nameEditTimeout: any = null;  // timeout pour effectuer l'appel de la fonction end onEditName
    contentEditTimeout: any = null;  // timeout pour effectuer l'appel de la fonction end onEditContent

    state: Readonly<IState> = {
        shareModalOpen: false,
    };

    /**
     * Fonction qui mests un timeout sur 1 seconde après chaque modification avant d'appeler le callback onEditNameEnd()
     * @param newName Le nouveau nom de la note
     */
    onEditName(newName: string) {
        if (this.nameEditTimeout) {
            clearTimeout(this.nameEditTimeout); // On annule le timeout précédent
        }
        this.nameEditTimeout = setTimeout(() => { // et on lance un timeout pour que dans une seconde on fasse la requête API si l'utilisateur arrète de taper
            this.props.onEditNameEnd(newName);
        }, 1000);
    }

    /**
     * Fonction qui trouve le nom de l'utilisateur à paritr de la liste des ID du NoteService
     */
    findUserName(): string {
        const { note } = this.props;
        const userId = note.createUserId;
        const teamUser = NotesService.connectedUsers.find(u => u.id === userId);
        if (teamUser) {
            return teamUser.displayName;
        }
        else return "";
    }

    /**
     * Fonction qui mests un timeout sur 1 seconde après chaque modification avant d'appeler le callback onEditContentEnd()
     * @param newContent Le nouveau contenu de la note
     */
    onEditContent(newContent: string) {
        if (this.contentEditTimeout) {
            clearTimeout(this.contentEditTimeout); // On annule le timeout précédent
        }

        this.contentEditTimeout = setTimeout(() => { // et on lance un timeout pour que dans une seconde on fasse la requête API si l'utilisateur arrète de taper
            this.props.onEditContentEnd(newContent);
        }, 1000);
    }

    render(): ReactNode {
        const { note, onDeleteNote, t } = this.props;
        const { shareModalOpen } = this.state
        return (
            <div className="note-container">
                <div className="note-header">
                    <input type="text" maxLength={100} className="note-title-input" onChange={e => this.onEditName(e.target.value)} defaultValue={note.name} />
                    <Menu
                        transition
                        hidden={this.findUserName().length > 0}
                        menuButton={
                            <span className={this.findUserName().length > 0 ? "delete-note-btn-hidden" : "delete-note-btn"}>
                                {this.findUserName().length <= 0 && <BiDotsVerticalRounded fill="black"/>}
                            </span>
                        }>
                        <MenuItem onClick={() => onDeleteNote()} disabled={this.findUserName().length > 0}><MdDelete className="menu-icon" /> {t("delete")} </MenuItem>
                        <MenuItem onClick={() => this.setState({ shareModalOpen: true })}><BiShareAlt className="menu-icon" /> {t("share")} </MenuItem>
                    </Menu>
                </div>

                <textarea maxLength={250}
                    className={(this.findUserName().length <= 0) ? "note-content-input" : "note-content-input shared-note-content"}
                    onChange={e => this.onEditContent(e.target.value)}
                    defaultValue={note.content} />

                {this.findUserName().length > 0 && <div className="note-origine"> {t("origin")} : {this.findUserName()}</div>}
                <ShareNoteModal
                    noteId={note.id}
                    open={shareModalOpen}
                    onClose={() => this.setState({ shareModalOpen: false })} />
            </div>
        )
    }
}

export default withTranslation()(NoteComponent);